import React, {useEffect} from 'react';
import {NotificationHeader} from "../components/notification/notifcation-header";
import {LOADING, SUCCESS} from "../httpClient";
import {useDispatch, useSelector} from "react-redux";
import {useAuth} from "oidc-react";
import {fetchNotificationsAsync} from "../features/notifications/notifcationSlice";
import {
    Container,
    createTheme,
    CssBaseline,
} from "@mui/material";
import Box from "@mui/material/Box";
import {ThemeProvider} from "@mui/styles";
import Loading from "../components/utils/loading";
import List from "@mui/material/List";
import {NotificationListItem} from "../components/notification/notification-list-item";

const theme = createTheme({
    typography: {
        fontFamily: [
            'Open Sans Condensed',
            'sans-serif'
        ].join(',')
    },
});

export const NotificationsPage = () => {

    const dispatch = useDispatch();
    const auth = useAuth();
    const {notifications, status} = useSelector(state => state.notification);

    useEffect(() => {
        if (auth && auth.userData && status !== SUCCESS) {
            dispatch(fetchNotificationsAsync(auth.userData.access_token))
        }
    }, [auth.userData, notifications]);

    if (status === LOADING) {
        return <div style={{
            marginTop: '3rem'
        }}>
            <Loading message={'one moment please'}/>
        </div>
    }
  return (<div>
        <NotificationHeader/>

          {
              status === SUCCESS  && notifications && notifications.length > 0 ?
                  <ThemeProvider theme={theme}>
                      <div>
                          <CssBaseline />
                          <Container maxWidth="lg" sx={{ mt: '3rem'}}>
                              <Box sx={{ width: '100%' }}>
                                  <List>
                                      {
                                          notifications.map(
                                              (notification) =>
                                                  <NotificationListItem notification={notification} key={notification.pid}/>
                                          )
                                      }
                                  </List>
                              </Box>
                          </Container>
                      </div>
                  </ThemeProvider>
                  : null
          }

  </div>
  )
}
